import { InputNumber as AntdInputNumber, InputNumberProps } from 'antd';

function InputNumber(props: InputNumberProps) {
  return (
    <AntdInputNumber
      {...props}
      style={{ width: '100%' }}
      decimalSeparator=","
    />
  );
}

export default InputNumber;
